import { Box, BoxProps, Typography, TypographyProps, styled } from '@mui/material';
import { ComponentProps, ReactElement, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { PoolRow } from '../pool-row/pool-row';

const Container = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.grey[700]}`,
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
}));

export interface PoolFormHeaderProps extends Omit<TypographyProps, 'id' | 'sx'> {
    id: string;
    // Allows inserting of components before and after the title
    slots?: {
        start?: ReactNode;
        end?: ReactNode;
    };
    formattedMessageProps?: Omit<ComponentProps<typeof FormattedMessage>, 'children' | 'id'>;
    sx?: {
        container?: BoxProps['sx'];
        header?: TypographyProps['sx'];
    };
}

export const PoolFormHeader = (props: PoolFormHeaderProps): ReactElement => {
    const { slots, id, formattedMessageProps, sx, ...typographyProps } = props;

    return (
        <Container sx={sx?.container}>
            <PoolRow>
                {slots?.start}
                <Typography variant="h6" {...typographyProps} sx={sx?.header}>
                    <FormattedMessage id={id} {...formattedMessageProps} />
                </Typography>
            </PoolRow>
            {slots?.end}
        </Container>
    );
};
